import React, { useState, useEffect, useMemo } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { SelectMultiple, Bubble } from 'tea-component';
import classNames from 'classnames';
import { getEntityTypeIcon } from '@/pages/home/pages/home/Explore/_config/common';
import { useIntl, getLocale } from 'umi';
import './index.scss';
import { formatDateStr } from '@intelligence/utils/dateUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import GameImage from '@/pages/home/components/GameImage';
import { getPlatformIcons, filterPlatformIcons } from '@intelligence/utils/common';
import { StatusBubbleContent } from '@intelligence/components/DataSourceComponents';

const groups = {
  All: 'Unified Product',
  App: 'App',
};
interface combinedGameItem {
  entity_type: string;
  id?: string;
  overlap_ids?: [];
}
export default function GameHeader(props: any) {
  const {
    basicInfo,
    appIdListAll,
    gameName,
    receiveSumFun,
    entityType,
    appIdList,
    setAppIdList,
    storage,
    dom,
    combinedGameList,
    releaseTime,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isCN = locale === 'zh-CN';
  const [iosNum, setIosNum] = useState<any>('');
  const [androidNum, setAndroidNum] = useState<any>('');
  const [isOperate, setIsOperate] = useState<any>(false);
  const [platform, setPlatform] = useState<any>({}); //{'id1':"ios",'id2':android}

  const isGlobalInactive = useMemo(() => {
    if (!appIdListAll || !Array.isArray(appIdListAll) || appIdListAll.length === 0) {
      return false;
    }
    const isAllSelected =
      !appIdList || appIdList.length === 0 || appIdList.length === appIdListAll.length;
    if (!isAllSelected) {
      return false;
    }
    return appIdListAll.every(
      (item: any) => item?.inactive === true || item?.unpublished === 1,
    );
  }, [appIdListAll, appIdList]);

  const options = useMemo<any>(() => {
    let appIdListTemp: any = [];
    let platformTmp: any = {};
    if (appIdListAll && Array.isArray(appIdListAll) && appIdListAll.length > 0) {
      appIdListTemp = appIdListAll?.map((item: any) => {
        let iocnType = 'a-select-icon';
        if (item.platform == 'ios') {
          iocnType = 'a-select-icon';
        }
        if (item.platform == 'android') {
          iocnType = 'video-icon';
        }

        platformTmp[item.id] = item.platform;

        const isInactive = item?.inactive === true;
        return {
          groupKey: 'App',
          value: item.id,
          text: (
            <div
              className={classNames({
                'dbi-details-popover-list': true,
                'dbi-details-popover-opacity': item?.unpublished === 1,
              })}
            >
              <SvgIcon type={iocnType} className="dbi-details-popover-icon" />
              <GameImage
                className="dbi-details-popover-img"
                src={item.cover}
                entityType={'mobile'}
              />
              <span className="dbi-details-popover-text">{item.name}</span>
              {isInactive ? (
                <Bubble placement="right" dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
                  <div className="dbi-details-popover_tip">
                    {formatMessage({ id: 'dbi_inactive' })}
                  </div>
                </Bubble>
              ) : null}
              {item?.unpublished === 1 ? (
                <Bubble placement="right" dark content={<StatusBubbleContent descId="dbi_offline_hover" />}>
                  <div
                    className="dbi-details-popover_tip dbi-details-popover_tip--offline"
                    style={isInactive ? { marginLeft: -6 } : undefined}
                  >
                    {formatMessage({ id: 'dbi_offline' })}
                  </div>
                </Bubble>
              ) : null}
            </div>
          ),
          type: item?.unpublished === 1 ? '2' : '1',
        };
      });
    }
    setPlatform(platformTmp);
    return appIdListTemp;
  }, [appIdListAll]);

  const appIdsAll = useMemo<any>(() => {
    return appIdListAll?.map((item: { id: any }) => item.id) || [];
  }, [appIdListAll]);

  useEffect(() => {
    let iosNumTemp = 0;
    let androidNumTemp = 0;
    if (appIdList && Array.isArray(appIdList) && appIdList.length > 0) {
      appIdList?.map((item: any) => {
        const appIdObj = appIdListAll?.find((subItem: any) => item == subItem.id);
        // console.log('appIdObj',appIdObj);
        // feat android|ios图标不展示的问题
        if (appIdObj.platform == 'ios' || appIdObj.platform == 'android|ios') {
          iosNumTemp++;
        }
        if (appIdObj.platform == 'android') {
          androidNumTemp++;
        }
      });
    }
    setIosNum(iosNumTemp);
    setAndroidNum(androidNumTemp);
  }, [appIdList]);

  const handleOnClose = () => {
    if (isOperate) {
      const appListTemp = appIdList?.length === 0 ? appIdsAll : appIdList;
      let arr: any = [];
      if (appListTemp?.length) {
        appListTemp.forEach((id: any) => {
          if (!arr.includes(platform[id])) {
            arr.push(platform[id]);
          }
        });
      }
      setAppIdList(appListTemp);
      receiveSumFun(appListTemp, arr, false);
      setIsOperate(false);
    }
  };

  const handleOnChange = (value: any) => {
    setIsOperate(true);
    setAppIdList(value);
  };

  const renderGameIcons = () => {
    const platformOrder = ['mobile', 'pc', 'console'];
    combinedGameList.sort((a: combinedGameItem, b: combinedGameItem) => {
      // 使用order.indexOf找到a和b在order数组中的索引
      const indexA = platformOrder.indexOf(a?.entity_type?.toLocaleLowerCase());
      const indexB = platformOrder.indexOf(b?.entity_type?.toLocaleLowerCase());

      // 如果a不在order中，则将其放在最后
      if (indexA === -1) return 1;

      // 如果b不在order中，则将其放在a之前
      if (indexB === -1) return -1;

      // 如果a和b都在order中，则按照order中的顺序进行排序
      return indexA - indexB;
    });
    if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE)
      return <SvgIcon type={getEntityTypeIcon(entityType)} className="desc-icon" />;
    return combinedGameList
      ?.filter((combineGame: combinedGameItem) => combineGame?.entity_type)
      ?.map((combineGame: combinedGameItem) => {
        const icon = getEntityTypeIcon(combineGame?.entity_type);
        return <SvgIcon key={`${combineGame?.entity_type}-${combineGame?.id}`} type={icon} className="desc-icon" />;
      });
  };

  return (
    <>
      <GameImage
        className={classNames({
          'right-header-img': true,
          'active-img-one': entityType === 'mobile',
          'active-img-two': entityType === 'pc',
          'active-img-there': ['console', PC_CONSOLE_COMBINE_ENTITY_TYPE].includes(entityType),
        })}
        src={basicInfo?.cover}
        entityType={entityType}
      />

      <div className="active-message" ref={dom}>
        <div className="active-message-title-wrap">
          <div className="active-message-title">{basicInfo?.name}</div>
          {isGlobalInactive && entityType === 'mobile' ? (
            <Bubble dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
              <span className="dbi-details-popover_tip">
                {formatMessage({ id: 'dbi_inactive' })}
              </span>
            </Bubble>
          ) : null}
        </div>

        <div className="active-message-multiple">
          {/* {basicInfo?.source_desc === 'ogdb' && <div className="active-message-multiple-theme">
            <Bubble
              dark
              placement="top"
              content="KPI Data proudly presented by DataBrain Scientist Team"
              style={{ minWidth: 380 }}>
              <img src={ThemeIcon} className="multiple-theme-img" />
            </Bubble>
          </div>} */}

          {entityType == 'mobile' && (
            <SelectMultiple
              className="dbi-details-multiple"
              // overlayClassName="dbi-details-multiple-overlay"
              boxClassName="intelligence-idinfoSelect"
              staging={false}
              groups={groups}
              allOption={{
                value: 'all',
                text: `All ${gameName} products`,
              }}
              listHeight={392}
              // listWidth={299}
              button={
                <div className="active-message-flex">
                  {iosNum * 1 > 0 ? (
                    <span className="text-spacing">
                      <SvgIcon type={'a-select-icon'} className="text-icon" /> {iosNum}
                    </span>
                  ) : null}
                  {androidNum * 1 > 0 ? (
                    <span className="text-spacing">
                      <SvgIcon type={'video-icon'} className="text-icon" /> {androidNum}
                    </span>
                  ) : null}
                  {iosNum * 1 > 0 || androidNum * 1 > 0 ? <div className="text-change" /> : null}
                </div>
              }
              options={options}
              value={appIdList}
              onChange={handleOnChange}
              onClose={handleOnClose}
            />
          )}

          {entityType == 'pc' && storage && (
            <div className="active-message-storage">
              <span className="desc-text">
                {formatMessage({ id: 'dbi_storage_required' })} : {storage}
              </span>
              {/* <span className='desc-text-price'>Price: $60</span> */}
            </div>
          )}

          {entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && (storage || false) && (
            <div className="active-message-storage">
              {storage && (
                <span className="desc-text">
                  {formatMessage({ id: 'dbi_storage_required' })} : {storage}
                </span>
              )}
              {/* {false && <span className="desc-text-price">Price: $60</span>} */}
            </div>
          )}

          {entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && basicInfo?.platforms?.length > 0 && (
            <div className="dbi-details-platform-icon-list">
              {filterPlatformIcons(basicInfo?.platforms)?.map((platform: string) =>
                platform === 'pc' ? (
                  <Bubble dark content={formatMessage({ id: 'dbi_pcdevice_icon_tooltips' })}>
                    <img
                      key={platform}
                      className="dbi-details-platform-icon-list__icon-item"
                      src={getPlatformIcons(platform, true)}
                    />
                  </Bubble>
                ) : (
                  <img
                    key={platform}
                    className="dbi-details-platform-icon-list__icon-item"
                    src={
                      getPlatformIcons(platform, true)
                      // getDataSourceIcon(platform === 'pc' ? 'steam' : platform)
                    }
                  />
                ),
              )}
            </div>
          )}

          {/* {entityType == 'console' && <div className="dbi-details-console-text">
            <img className='dbi-details-console-img' src={Newzoo} />
            <img className='dbi-details-console-img' src={Xbox} />
          </div>} */}
        </div>

        <div className="active-message-desc">
          {renderGameIcons()}
          <span className="desc-text">
            {`${formatMessage({ id: 'dbi_release_date' })}: ${releaseTime}`}
          </span>
        </div>
      </div>
    </>
  );
}
